import {Component, effect, input, output, signal} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatButton} from "@angular/material/button";
import {MatOption, MatSelect} from "@angular/material/select";
import {KeyValuePipe} from '@angular/common';
import {TokenRequestModel} from "../entities/token-request";
import {AmadWebNetworkService} from "../network/amad-web-network.service";
import {LoaderService} from "../services/loader.service";
import {CacheService} from "../services/cache.service";
import {ComponentEntity} from "../entities/component-entity";
import {ApplicantProject, TypeInputPersonalInformation} from "../entities/projects.entities";
import {SepomexService} from "../network/sepomex/sepomex.service";
import {ROUTER_VIEW} from "../commons/constans";
import {Router} from "@angular/router";
import {environment} from "../../environments/environment";
import {DeviceDetectorService} from "ngx-device-detector";

@Component({
  selector: 'app-personal-data-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatButton,
    MatLabel,
    MatSelect,
    MatOption,
    KeyValuePipe,
  ],
  templateUrl: './personal-data-form.component.html',
  styleUrl: './personal-data-form.component.css'
})
export class PersonalDataFormComponent {
  onclick = output()
  form: FormGroup;
  tokenRequestModel= input<TokenRequestModel>({
    android_version:"",
    id_application:environment.idApplication,
    model:"",
    phone_number:"",
    phone_id:"",
    other_information:{
      lat:0,
      long:0,
      origin:"",
      state:"",
      telMarcado:"",
      colonia:""
    }
  })
  applicantProject = signal<ApplicantProject|null>(null)
  geolocation?:GeolocationPosition=undefined
  typeLocalization =""
  KEY_COLONIA="Colonia"
  KEY_MUNICIPIO="Municipio"
  KEY_ESTADO="Estado"
  constructor(private fb: FormBuilder,
              private analytics:AmadWebNetworkService,
              private loaderService: LoaderService,
              private sepomexService: SepomexService,
              private router: Router,
              private cacheService:CacheService,
              private deviceService: DeviceDetectorService,
  ) {
    navigator.geolocation.getCurrentPosition(position =>
      {
        this.geolocation = position
      }
    )

    this.applicantProject.set(cacheService.get(CacheService.APP_INFORMATION) as ApplicantProject)
    this.form = this.fb.group({
      nombre: ['', ],
      telefono: ['',],
      estado: ['AGS', ],
      correo: ['', ],
    });

    if(this.applicantProject()?.personalInformation.locationInformation.municipality){
      this.typeLocalization=this.KEY_COLONIA
      this.sepomexService.listNeighborhood(this.applicantProject()?.personalInformation?.locationInformation?.municipality?.id_municipio ??0).subscribe(value => {

        this.data  = value.reduce((acc, curr) => {
          acc[curr.colonia.toString()] = curr.id_colonia.toString();
          return acc;
        }, {} as { [key: string]: string })
      })
    }
    else if(this.applicantProject()?.personalInformation.locationInformation.state){
      this.typeLocalization=this.KEY_MUNICIPIO

      this.sepomexService.listMunicipality(this.applicantProject()?.personalInformation?.locationInformation?.state?.id_estado ??0).subscribe(value => {
        this.data  = value.reduce((acc, curr) => {
          acc[curr.municipio.toString()] = curr.id_municipio.toString();
          return acc;
        }, {} as { [key: string]: string })
      })

    }else if(this.applicantProject()?.personalInformation.locationInformation.state == undefined){
      this.typeLocalization=this.KEY_ESTADO

      this.sepomexService.listStates().subscribe(value => {
        this.data  = value.reduce((acc, curr) => {
          acc[curr.estado.toString()] = curr.id_estado.toString();
          return acc;
        }, {} as { [key: string]: string })
      })
    }
  }

  onSubmit() {
    if (this.form.valid) {
      this.loaderService.show()

      let request = this.tokenRequestModel()!

      request.android_version = `${this.deviceService.browser}/${this.deviceService.os}`
      request.id_application = environment.idApplication
      request.model = this.deviceService.device
      request.other_information.telMarcado = this.form.controls['telefono'].value;
      request.other_information.state = this.form.controls['estado'].value;
      request.other_information.lat = this.geolocation?.coords.latitude ?? 0;
      request.other_information.long = this.geolocation?.coords.longitude ?? 0;

      if(this.typeLocalization == this.KEY_COLONIA){
        request.other_information.state =""
        request.other_information.colonia = this.form.controls['estado'].value
      }
      this.analytics.load(request).subscribe(() => {

        this.analytics.sendClicks({
          id_action:this.applicantProject()?.preconfiguration.tagAnalyticOpen ?? "",
          other_information:"opened"

        }).subscribe(value => {

          let mainView =
            this.applicantProject()?.views.find(view => {
              return view.mainView;
            })
          this.router.navigate([`/${ROUTER_VIEW}`, mainView?.id ?? "" ]);
        })
        this.onclick.emit()
        this.loaderService.hide()
      })
    }
  }

  data: { [key: string]: string } = {
  }
  protected readonly TypeInputPersonalInformation = TypeInputPersonalInformation;
}
